<template>
  <v-btn class="btn-danger" @click="deleteChild()">削除</v-btn>
</template>

<script>
export default {
  props: {
    routes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      cancelAdminRoute: this.routes.cancelAdminRoute,
    };
  },

  methods: {
    deleteChild() {
      if (window.confirm("子会員を削除します。よろしいですか?")) {
        window.location.href = this.cancelAdminRoute;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-danger {
  background: #dc3545 !important;
  color: white;
}

@media screen and (max-width: 750px) {
  .v-btn {
    min-width: 60px !important;
    margin: 0 0 0 3px;
  }
}
</style>
